<template>
  <div>
    <HeadDetailsGama :btnCanceSave="false" :btnImportPdf="true" v-on:openFile="openFile" @openUploadPopup="openUploadPopup" :titleHead="title"></HeadDetailsGama>
    <div id="body-details">
        <div id="head-details" class="pt-2">
          <div class="w-25 input-rela">
          </div>
        <div class="DashButton">
          <input type="file" v-on:change="imporTable" id="impor-ex" itemid="impor-ex">
            <!--
              <button v-on:click="openFile" class="btn-new-gru mr-2"><i class="fas fa-file-excel mr-2"></i>IMPORTAR TABELA
            EXCEL</button> -->
            <div>
          </div>
        </div>
       <div class="separa-conteudo">
            <Tables ref="tableDocuments"
            :columns="headTable"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
        >
            <tr v-for="document in dataPdf" v-bind:key="document.id">
                <TableColumn :IsText="true"    :status="1" :value="document.arquivo.descricao" />
                <TableColumn :IsText="true"    :status="1" :value="document.descricaoConteudo" />
                <TableColumn class="button-down-del" :IsActionsButtons="false" :IsDocumentActions="true" v-on:Edit="Edit(document)" v-on:Delete="Delete(document.id)" :status="1"
                :HasChange="false" :HasDetails="false" v-on:Download="onDownloadDocument(document.id)" :HasDownload="true"/>
            </tr>
        </Tables>
       </div>
          <b-modal
            hide-footer
            centered
            ref="addtablepricemodal"
            id="addtablepricemodal"
            title="Adicionar novo documento">
            <template #modal-title>
              <div class="header-title">ADICIONAR IMAGEM E PDF</div>
            </template>
            <input type="file" v-on:change="GetValueFile" id="impor-pdf" itemid="impor-pdf">
            <div class="embaixo">
              <div class="d-flex justify-content-center">
                <div>
                  <div v-if="this.nameInput == '' " v-on:click="openFilePdf" class="Icon">
                    <i class="fas fa-file-image"></i>
                  </div>
                  <div v-if="this.nameInput != ''" v-on:click="openFilePdf" class="Icon">
                    <i class="fas fa-file-pdf"></i>
                  </div>
                </div>
              </div>
              <div>
                <div class="d-flex justify-content-center mt-2">
                  <label>{{ nameInput }}</label>
                </div>
              </div>
            </div>
            <div class="section-destinations">
              <div class="enterprise-select" >
                <b-form-group  label="Descrição do Conteúdo">
                    <b-form-textarea
                    v-model="descricaoConteudo"
                    type="text"
                    ></b-form-textarea>
                </b-form-group>
              </div>
            </div>
            <div class="container-buttons-form mt-3 pt-3">
              <!-- <button @click="RemovePdf" class="button-delete">Deletar</button> -->
              <button @click="closeUploadPopup" class="button-cancel">Cancelar</button>
              <button @click="imporTablePdf" class="button-save" id="save-pdf">Salvar</button>
            </div>
          </b-modal>

          <!-- The Modal -->
          <div id="myModal" class="modal">

            <!-- The Close Button -->
            <span class="close">&times;</span>

            <!-- Modal Content (The Image) -->

            <img class="modal-content" id="img01">
          </div>
        <!-- </div> dashbutton -->
      </div>
      <Collapsemirrorsales v-for="(data, i) in dataParcela"  :dataTable="dataUnidade" v-bind:key="i"
        :dataParcela="data" :id="i > 1 ? op[2] : op[i]" :ordem="index" :title="data.nome">
      </Collapsemirrorsales>
    </div>
  </div>
</template>

<script>
import Mirrorsalesenterprise from './mirrorsalesenterprise'
export default Mirrorsalesenterprise
</script>

<style scoped>
.header-title {
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}
.container-buttons-form {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.embaixo {
  display: flex;
  flex-direction: column;
}

#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}

.modal-content,
#caption {
  animation-name: zoom;
  animation-duration: 0.6s;
}

#impor-ex {
  display: none;
}

#impor-pdf {
  display: none;
}

.btn-new-gru {
  height: 30px;
  width: 230px;
  background: white;
  font-size: 14px;
  color: #008148;
  font-weight: bold;
  border: 1px solid #008148;
  margin: 0px;
  border-radius: 6px;
}

.btn-new-gru:hover {
  color: white;
  background: #008148;
}

.componente {
  font-size: 18px;
  color: black;
  padding-top: 9px;
  padding-left: 15px;
}

.input-rela {
  position: relative;
}

.DashButton{
  grid-area: DashButton;
  justify-self: end;
}

.separa-conteudo{
  grid-area: separaConteudo;
  border-top: 1px solid #008148;
  width: 100%;
  height: 100%;
}

#head-details {
  display: grid;
  /* grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 0.5fr 2fr; */
  grid-template-areas: ". DashButton"
                       "separaConteudo separaConteudo";
  gap: 15px;
  /* display: flex;
  justify-content: space-between;
  height: 30rem;
  background-color: purple; */
}

.button-cancel,
.button-delete,
.button-save {
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}

.button-cancel {
  background-color: #dedede;
  color: #747474;
}

.button-save {
  background-color: #008148;
  color: white;

}

.button-delete {
  background-color: #be2b2b;
  color: white;
}

.Icon {
  align-items: center;
  display: flex;
  width: 170px;
  height: 150px;
  color: rgb(147, 137, 139);
  background-color: #dedede;
  font-size: 50px;
  justify-content: center;
  border-style: dotted;
  cursor: pointer;
  border-radius: 10px 10px 10px 10px;

}

.button-down-del{
  display: flex;
  padding-top: 20px;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/enterprise/components/mirrorsalesenterprise/mirrorsalesenterprise.vue